import * as React from 'react';
import { InjectedRouter, PlainRoute } from 'react-router';

import AdminDefaultClassSettingsContainer from './AdminDefaultClassSettingsContainer';
import AdminDefaultClassSettingsView from './AdminDefaultClassSettingsView';
import { OrganizationType } from 'globalTypes';
import { withRouter } from 'app/context/Router';
import { ChildProps as ContainerChildProps } from 'admin/components/AdminDefaultClassSettings/components/AdminDefaultClassSettingsContainer';

type Props = {
  organizationUUID: string;
  params: { groupCode: string };
  orgType: OrganizationType;
  route: PlainRoute;
  router: InjectedRouter;
};

function AdminDefaultClassSettings(props: Props) {
  return (
    <AdminDefaultClassSettingsContainer
      organizationUUID={props.organizationUUID}
      groupCode={props.params.groupCode}>
      {({
        classesDefaultSettings,
        activeGroupCount,
        setOrgClassDefaults,
        paidAt,
      }: ContainerChildProps) => (
        <AdminDefaultClassSettingsView
          orgType={props.orgType}
          classesDefaultSettings={classesDefaultSettings}
          // Only paid or orgs in a demo can see this screen. Not being paid -> they're only in demo
          orgIsDemoOnly={paidAt === null}
          activeGroupCount={activeGroupCount}
          setOrgClassDefaults={setOrgClassDefaults}
          orgUuid={props.organizationUUID}
          route={props.route}
          router={props.router}
        />
      )}
    </AdminDefaultClassSettingsContainer>
  );
}

export { AdminDefaultClassSettings };

export default withRouter(AdminDefaultClassSettings);
